export default [
  // 新用户调研
  {
    path: '/new-user-research',
    name: 'NewUserResearch',
    component: () => import('@/upgrade-page/views/new-user/research/index.vue')
  }
];
